import requiredSubmitKeys from '../constants/requiredSubmitKeys';
import { capitalCase } from 'change-case';

export default function (checkoutConfiguration) {
	const errors = [];

	Object.keys(checkoutConfiguration).forEach((key) => {
		if (requiredSubmitKeys.includes(key) && checkoutConfiguration[key].length === 0) {
			errors.push({
				type: key,
				message: `${capitalCase(key)} field is required`
			});
		}
	});

	return errors;
}
